<template>
  <b-container fluid class="column">
    <b-row>
      <b-col :style="{ backgroundImage: `url('${bg}')`, backgroundSize: `43%`, backgroundRepeat: `no-repeat`, backgroundPosition: `right 4rem center`}">
        <b-row>
          <b-col cols="7" md="3" class="mt-3">
            <h4>Send results</h4>
          </b-col>
          <b-col cols="5" md="9" class="text-right">
            <b-button class="btn-circle btn-md p-0 mb-2" id="exitButton" @click="close()">
              <b-img id="exitLogo" :src="require('../assets/pngIcons/btn_close_small.png')" center></b-img>
            </b-button>
          </b-col>
        </b-row>

        <b-col md="7">
          <b-col offset>
            <b-row class="mb-3 mt-3">
              <b-col cols="2">
                <label for="name">Name</label>
              </b-col>
              <b-col cols="10">
                <b-col offset="1">
                  <b-form-input
                    v-model="name"
                    class="rounded-pill input"
                    id="name"
                    type="text"
                    placeholder="-"
                  ></b-form-input>
                </b-col>
              </b-col>
            </b-row>

            <b-row class="my-3">
              <b-col cols="2">
                <label for="company">Company</label>
              </b-col>
              <b-col cols="10">
                <b-col offset="1">
                  <b-form-input
                    v-model="company"
                    class="rounded-pill input"
                    id="company"
                    type="text"
                    placeholder="-"
                  ></b-form-input>
                </b-col>
              </b-col>
            </b-row>

            <b-row class="my-3">
              <b-col cols="2">
                <label for="country">Country</label>
              </b-col>
              <b-col cols="10">
                <b-col offset="1">
                  <b-form-input
                    v-model="country"
                    class="rounded-pill input"
                    id="country"
                    type="text"
                    placeholder="-"
                  ></b-form-input>
                </b-col>
              </b-col>
            </b-row>

            <b-row class="my-3">
              <b-col cols="2">
                <label for="email">Email</label>
              </b-col>
              <b-col cols="10">
                <b-col offset="1">
                  <b-form-input
                    v-model="email"
                    class="rounded-pill input"
                    id="email"
                    type="text"
                    placeholder="-"
                  ></b-form-input>
                </b-col>
              </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col offset="2" class="mb-5">
                <b-col v-show="error" offset="1">
                  <b-alert show variant="danger"><strong>Oops!</strong> Something went wrong. Please try again.</b-alert>
                </b-col>
                <b-col v-show="submitted" offset="1">
                  <b-alert show variant="primary"><strong>Success!</strong> Your results has been sent, please check you inbox!</b-alert>
                </b-col>
                <b-col v-show="!submitted" offset="1">
                  <b-button id="sendButton" class="rounded-pill p-0 mb-4" @click="sendForm">Send</b-button>
                  <p id="privacyText">
                    By clicking on Send results you agree to let Gunnebo
                    <br />Industries store your email address to follow up on the calculation results.
                    <a
                      id="privacyLink"
                      href="https://www.gunneboindustries.com/Global/Lifting/Policy/GunneboIndustries_Privacy_Policy.pdf"
                      target="_blank"
                    >Privacy policy</a>
                  </p>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FormBackground from "../assets/images/form_bg-img_large.png";
export default {
  data() {
    return {
      name: null,
      company: null,
      country: null,
      email: null,
      submitted: false,
      error: false,
      bg: FormBackground
    };
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
    sendForm() {
      var self = this;
      var data = {
        name: this.name,
        email: this.email,
        company: this.company,
        country: this.country,
        adjustments: this.$parent.adjustments,
        costSavedDay: this.$parent.costSavedDay,
        costSavedLift: this.$parent.costSavedLift,
        cph: this.$parent.cph,
        craneCost: this.$parent.craneCost,
        ftm: this.$parent.ftm,
        laborCost: this.$parent.laborCost,
        lifts: this.$parent.lifts,
        maxLine: this.$parent.maxLine,
        otherCost: this.$parent.otherCost,
        selected: this.$parent.selected,
        sheavesReeved: this.$parent.sheavesReeved,
        slingLength: this.$parent.slingLength,
        timeSavedDay: this.$parent.timeSavedDay,
        timeSavedLift: this.$parent.timeSavedLift,
        winchLineSpeed: this.$parent.winchLineSpeed
      };

      fetch("/api/results", {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then(function(res) {
        if (res.status === 200){
          self.error = false;
          self.submitted = true;
        }
        else {
          self.error = true;
          self.submitted = false;
        }
      });
    }
  }
};
</script>

<style scoped>

.alert {
    color: white;
    border: none;
}

.alert-danger {
  background-color: #c90000;
}

.alert-primary {
  background-color: #0492c6;
}

#sendButton {
  height: 2.5rem;

  background-color: #000000;
  font-size: 1.2em;
  color: #0492c6;

  border-width: 0.2rem;
  border-color: #0492c6;

  text-align: center;
}

.btn-circle.btn-md {
  width: 50px;
  height: 50px;
  padding: 7px 10px;
  border-radius: 25px;
  font-size: 10px;
  text-align: center;
}

#exitButton {
  background-color: transparent;
  border: none;
}

#exitButton:focus {
  box-shadow: none;
}

#privacyText {
  color: #a8a8a8;
  font-size: 0.8em;
}

#privacyLink {
  color: #0492c6;
  text-decoration: underline#0492c6;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: none;
  -webkit-text-fill-color: #ffffff;
  -webkit-box-shadow: 0 0 0px 1000px #3d3d3d inset;
  box-shadow: 0 0 0px 1000px #3d3d3d inset;
  transition: background-color 5000s ease-in-out 0s;
}
</style>